import { showMutationError } from '@/shared/lib'

import { useTelegramLink } from '@/apps/adok/entities/telegram-account'

export function useOpenTelegramBot() {
  const { mutateAsync: requestLink, isPending: isOpening } = useTelegramLink()

  // Clicks only, never on mount: the request marks the account as having clicked
  // the Telegram banner.
  async function openBot() {
    // Blank and before the `await`: after one, Safari and iOS block `window.open`
    // as a popup.
    const tab = window.open('', '_blank')
    if (tab) tab.opener = null

    try {
      const response = await requestLink()
      if (tab) tab.location.href = response.data.data.link
    } catch (error) {
      tab?.close()
      showMutationError(error, 'Could not open the Telegram bot.')
    }
  }

  return { openBot, isOpening }
}
